import script from "./OrderRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderRegister.vue?vue&type=script&setup=true&lang=ts"

import "./OrderRegister.vue?vue&type=style&index=0&id=87477a7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87477a7e"]])

export default __exports__